import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Icon } from '@atlas/ui';

import { defaultRoutes } from 'components/MainRouter/constants';
import SimpleMenu from 'components/SimpleNavigation/SimpleMenu';

const hiddenPaths = ['/menu', '/account'];

const { MENU } = COMPONENT_TYPES;

const { menu: menuDefaultRoute } = defaultRoutes;

const SimpleNavigation = () => {
  const defaultMenuPath = React.useMemo(
    () => SiteConfigManager.getComponentPath(MENU) || menuDefaultRoute,
    [],
  );
  const { pathname } = useLocation();

  if (hiddenPaths.some(path => pathname.startsWith(path))) {
    return null;
  }

  return (
    <div className="simple-navigation">
      <Link className="simple-menu-burger" to={defaultMenuPath}>
        <Icon className="icon-menu" name="menu" />
      </Link>
      <SimpleMenu />
    </div>
  );
};

export default SimpleNavigation;
